<div [formGroup]="this.formGroup" class="mt-{{FIELD_SPACING}}">
  <div class="row">
    <div class="col-md-12">
        <div class="form-label">
          {{this.label}}<br *ngIf="this.label2"/>{{this.label2}}
          <span *ngIf="this.isOptional" class="optional-tag">&nbsp;(optional)&nbsp;</span>
          <span *ngIf="this.tooltip != null">
            <app-help-tooltip id="{{this.propertyId+'Tooltip'}}" [tooltipMessage]="this.tooltip"></app-help-tooltip>
          </span> 
        </div>
    </div>
    <div *ngIf="this.subText != null" class="col-md-12">
      <div [innerHTML]="this.subText"></div>
    </div>
  </div>
  <div class="row mt-{{LABEL_SPACING}}">
    <div class="col col-md-{{columns}}">
        <input 
          id="{{this.propertyId}}" 
          class="form-control mr-2"
          [ngClass]="[this.isInvalid() ? 'is-invalid' : '',  regular ? '' : 'input-box']"
          type="text" 
          maxlength={{this.maxLength}}
          formControlName="{{this.propertyName}}"
          (input)="this.userDataEntryAction($event)"
          (blur)="this.userAction($event)"
          mask="0*">
    </div>
  </div>
  <app-validator-message [formGroup]="this.formGroup" propertyName="{{this.propertyName}}"></app-validator-message>
</div>